<template>
    <MagTileLayer />

    <MagToast />

    <MagPopoverLayer />

    <XUpload v-if="uploads.length > 0" />

    <div v-if="debug" id="devTicker"><span>DEV BUILD</span></div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from "vue";
import { uploads } from "@/scripts/upload";
import { useSoundFx } from "@/scripts/sound";
import { useLegacyStream, useStreamFiltered } from "@/composables/use-stream";
import { PackNotification } from "magnetar-common/built/types/PackNotification";
import MagToast from "@/components/MagToast.vue";
import { magToast, ToastAdapterNotification } from "@/composables/mag-toast";
import { useAccountStore } from "@/model/account";
import { storeToRefs } from "pinia";
import { debug } from "@/config";
import MagPopoverLayer from "@/components/layout/MagPopoverLayer.vue";
import MagTileLayer from "@/components/layout/MagTileLayer.vue";

const XUpload = defineAsyncComponent(
    () => import("../../components/upload.vue"),
);

const accountStore = useAccountStore();
const { currentUser } = storeToRefs(accountStore);

const sfx = useSoundFx();

const legacyStream = useLegacyStream();

const onNotification = (notification: PackNotification) => {
    if (
        !currentUser.value?.notification_settings.enabled?.includes(
            notification.type,
        )
    )
        return;

    if (document.visibilityState === "visible") {
        legacyStream.value?.send("readNotification", {
            id: notification.id,
        });
        magToast({ notification }, ToastAdapterNotification);
    }

    sfx.play("notification");
};

useStreamFiltered("Notification", onNotification);
</script>

<style lang="scss">
@keyframes progress-spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

#wait {
    display: block;
    position: fixed;
    z-index: 4000000;
    top: 15px;
    right: 15px;

    &:before {
        content: "";
        display: block;
        width: 18px;
        height: 18px;
        box-sizing: border-box;
        border: solid 2px transparent;
        border-top-color: var(--accent);
        border-left-color: var(--accent);
        border-radius: 50%;
        animation: progress-spinner 400ms linear infinite;
    }
}

#devTicker {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2147483647;
    color: black;
    background-color: silver;
    mix-blend-mode: exclusion;
    font-weight: bold;
    padding: 4px 5px;
    font-size: 14px;
    pointer-events: none;
    user-select: none;
}
</style>
